import {
  RECIPIENT_COPY_INDENT_PX,
  ROW_PADDING_LEFT_PX,
  SELECTABLE_ROW_PADDING_LEFT_PX,
} from './DocumentItem.constants';

export const getDocumentItemStyles = (theme, { isSelectable, isDeleted, isNested } = {}) => ({
  root: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  name: {
    flex: 1,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  metaRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    minWidth: 0,
    overflow: 'hidden',
  },
  // The date always renders in full; only the discriminator chip (the last, most
  // flexible member of metaRow) yields space and ellipsizes when the row is narrow.
  metaDate: {
    flexShrink: 0,
  },
  metaSeparator: {
    flexShrink: 0,
    opacity: 0.6,
  },
  // A master's copies expand through DocumentRecipientCopiesToggle; MUI's chevron would sit
  // over the row's checkbox.
  iconContainer: {
    display: 'none',
  },
  typeLabel: {
    paddingLeft: 0,
  },
  draggable: {
    display: 'grid',
    alignItems: 'center',
    gridTemplateColumns: `${isSelectable ? 'auto ' : ''}1fr auto`,
    gap: '8px',
    width: '100%',
    padding: `2px 10px 2px ${
      (isSelectable ? SELECTABLE_ROW_PADDING_LEFT_PX : ROW_PADDING_LEFT_PX) +
      (isNested ? RECIPIENT_COPY_INDENT_PX : 0)
    }px`,
  },
  documentTreeItem: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    borderLeft: '2px solid transparent',
    '&:hover': {
      '& [data-name="delete-document-button"], & [data-name="restore-document-button"]': {
        visibility: 'visible',
        opacity: 1,
      },
    },
  },
  selected: {
    borderColor: isDeleted ? theme.palette.error.light : theme.palette.secondary.main,
    color: theme.palette.secondary.main,
    opacity: 1,
  },
  toBeMerged: {
    borderColor: theme.palette.text.primary,
    opacity: 1,
  },
  isDeleted: {
    color: theme.palette.error.light,
  },
  deleteButton: {
    visibility: 'hidden',
    opacity: 0,
    transition: 'visibility 0.15, opacity 0.15',

    '& > *': {
      pointerEvents: 'none',
    },
  },
});
